export enum ChannelName {
  EXTERNAL = 'External',
  AMD = 'AMD',
  FMT = 'FMT',
  RESEARCH = 'Research',
  AMILI_ANALYTICS = 'Amili Analytics', // FFH
  AMILI_HEALTH = 'Amili Health', // Consumer Health + Clinical Business
  CONSUMER_HEALTH = 'Consumer Health',
}
